import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { TranslationControlsComponent } from './translation-controls.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [TranslationControlsComponent],
  imports: [
    CommonModule,
    PhoenixDirectivesModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
  ],
  exports: [TranslationControlsComponent],
})
export class TranslationControlsComponentModule {}
